// @ts-check
import React, { Component } from "react"
import {
    objectPicker,
    fieldPicker,
    objectFilters,
    objectOrder,
} from "../../attributes/items/primitives"
import RecordTable from "../../../studio/components/RecordTable"

/**
 * @augments {Component<BlockTypeProps<{object: string}>, any>}
 */
export default class RecordTableBlock extends Component {
    state = { edits: { edit: null, callback: null } }

    render() {
        const Wrapper = this.props.Wrapper
        return (
            <Wrapper {...this.props}>
                {({ attrs, evaluateFormulas }) => (
                    <RecordTable
                        objectId={evaluateFormulas(attrs.objectId)}
                        dataFilters={evaluateFormulas(attrs.dataFilters)}
                        order={evaluateFormulas(attrs.order)}
                        onDataFiltersChange={dataFilters =>
                            this.props.utils.updateAttributes("dataFilters", dataFilters)
                        }
                    />
                )}
            </Wrapper>
        )
    }
}

RecordTableBlock.attributes = [
    objectPicker({ field: "objectId", label: "Data source" }),
    fieldPicker({ field: "fields", label: "Columns" }),
    objectFilters({ field: "dataFilters", label: "data filters" }),
    objectOrder({ field: "order", label: "default ordering" }),
]



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/data/RecordTableBlock.js